export enum WebhookEvent {
  AgreementCreated = 'AGREEMENT_CREATED',
  AgreementActionRequested = 'AGREEMENT_ACTION_REQUESTED',
  AgreementActionCompleted = 'AGREEMENT_ACTION_COMPLETED',
  AgreementWorkflowCompleted = 'AGREEMENT_WORKFLOW_COMPLETED',
  ManualReplay = 'MANUAL_REPLAY'
}